@if (!isLink && !dropdown()) {
<button
  [attr.type]="type()"
  [class]="hostClasses"
  [disabled]="isDisabled"
  [attr.aria-label]="resolvedAriaLabel"
  [attr.aria-busy]="loading() ? true : null"
  [attr.aria-pressed]="active() ? true : null"
  (click)="onClick($event)">
  <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</button>
}

@if (!isLink && dropdown()) {
<div
  ngbDropdown
  class="dropdown sb-button-dropdown"
  [class.d-inline-block]="!block()"
  [class.w-100]="block()">
  <button
    ngbDropdownToggle
    [attr.type]="type()"
    [class]="hostClasses"
    [disabled]="isDisabled"
    [attr.aria-label]="resolvedAriaLabel"
    [attr.aria-busy]="loading() ? true : null"
    [attr.aria-haspopup]="true"
    (click)="onClick($event)">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </button>
  <div ngbDropdownMenu>
    <ng-content select="[sbButtonMenu]"></ng-content>
  </div>
</div>
}

@if (isLink && routerLink() != null) {
<a
  [routerLink]="isDisabled ? null : routerLink()"
  [queryParams]="queryParams()"
  [fragment]="fragment()"
  [attr.href]="isDisabled ? null : undefined"
  [attr.target]="target()"
  [attr.rel]="rel()"
  [class]="hostClasses"
  [attr.aria-label]="resolvedAriaLabel"
  [attr.aria-busy]="loading() ? true : null"
  [attr.aria-disabled]="isDisabled ? true : null"
  [attr.tabindex]="isDisabled ? -1 : null"
  (click)="onClick($event)">
  <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</a>
}

@if (isLink && routerLink() == null) {
<a
  [attr.href]="isDisabled ? null : href()"
  [attr.target]="target()"
  [attr.rel]="rel()"
  [class]="hostClasses"
  [attr.aria-label]="resolvedAriaLabel"
  [attr.aria-busy]="loading() ? true : null"
  [attr.aria-disabled]="isDisabled ? true : null"
  [attr.tabindex]="isDisabled ? -1 : null"
  (click)="onClick($event)">
  <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</a>
}

<ng-template #contentTpl>
  @if (loading()) {
  <span class="btn-wrapper--icon sb-button__spinner" role="status" aria-hidden="true">
    <span class="spinner-border spinner-border-sm"></span>
  </span>
  }
  @if (showIconStart) {
  <span class="btn-wrapper--icon" aria-hidden="true">
    <i [class]="icon()"></i>
  </span>
  }
  @if (showLabel) {
  <span class="btn-wrapper--label">{{ label() }}</span>
  }
  <ng-content></ng-content>
  @if (showIconEnd) {
  <span class="btn-wrapper--icon" aria-hidden="true">
    <i [class]="icon()"></i>
  </span>
  }
</ng-template>
